import React from 'react';

function PartnersSection({content}) {
    return (
        <section className={content.backgroundColor === 'grey' ? 'tap' : 'investors'}>
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 text-center">
                        <h3>{content.title}</h3>
                    </div>
                </div>
                <div className="row">
                    <div className="references text-center">
                        <div className="images row">
                            {
                                content.logos.map((logo, index) => {
                                    return (
                                        <div className="images--image col col-6 col-sm-4 col-md-3 col-lg-2" key={index}>
                                            <a href={logo.title} target="_blank" rel={'noreferrer'}>
                                                <div className="inner">
                                                    <img src={logo.url} alt={logo.title}/>
                                                </div>
                                            </a>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default PartnersSection;
